// Шаги трекинга заказа — то, что видит покупатель.
//   доставка:  Новый → Собран → У курьера → Завершён
//   самовывоз: Новый → Собран → Завершён        (шага курьера нет — заказ забирают из магазина)
// «На упаковке» (packaging) — внутренний статус сотрудников (режим упаковки в праздники):
// покупателю его не показываем, для него заказ ещё «Новый». Чистые функции без зависимостей —
// покрыты тестом (src/__tests__/orderStatusLabels.test.js), TrackOrderPage берёт их отсюда.

// Шаги только для доставки — держать в согласии с order_statuses.DELIVERY_ONLY_STATUSES
export const DELIVERY_ONLY_STEPS = ['courier'];

const ALL_STEPS = ['new', 'ready', 'courier', 'completed'];

/** Шаги для заказа с таким типом доставки */
export const trackingSteps = (deliveryType) => (
  deliveryType === 'pickup' ? ALL_STEPS.filter((s) => !DELIVERY_ONLY_STEPS.includes(s)) : ALL_STEPS
);

// Внутренний статус → что видит покупатель
export const CUSTOMER_STATUS_ALIAS = { packaging: 'new' };

export const customerStatus = (status) => CUSTOMER_STATUS_ALIAS[status] || status;

/** Номер шага для статуса; неизвестный и отменённый — первый шаг */
export const stepIndexOf = (status, deliveryType) => {
  const idx = trackingSteps(deliveryType).indexOf(customerStatus(status));
  return idx >= 0 ? idx : 0;
};
